import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomService {

  //Behavior Subject for Custom Field
  private custom = new BehaviorSubject('');

  getCustom(): Observable<any> {
    return this.custom.asObservable();
  }

  setCustom(field) {
    this.custom.next(field);
  }

   //Behavior Subject for Section
   private section = new BehaviorSubject('');

   getSection(): Observable<any> {
     return this.section.asObservable();
   }
 
   setSection(section) {
     this.section.next(section);
   }

  constructor(private http: HttpClient) { }

  getAllModules() {
    return this.http.get<any>(`${environment.configUrl}LionO360_Object`)
  }
}
